/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PayrollReportView {
  ACTIONS_REQUIRED_SINCE = 'ACTIONS_REQUIRED_SINCE',
  FULL_PAY_PERIOD = 'FULL_PAY_PERIOD',
}
